import React, { Component } from 'react';
import { cloneDeep } from 'lodash';
import { Form, Input, Modal , Table, columns} from 'antd';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';
import API from "../scripts/api";
import moment from "moment-jalaali";
import { Constants, Permissions } from "../scripts/settings";

class SearchDetailForm extends Component {
    constructor() {
        super();

        this.state = {
            data: []
        };

        this.formRef = React.createRef();
    }



    handleWillUnmount = () => {
        // this.formRef.current.resetFields();
    }

    handleDidMount = async (user_id, startDate, endDate) => {

  
    await this.getDatail(user_id, startDate, endDate)
    }

    getDatail = (user_id, startDate, endDate) => {
       
      
        let params = {
          user_id : user_id,
          startDate : startDate,
          endDate: endDate
        }
        this.setState({ loading: true });
    
        API.searchReport
          .detail(params)
          .then((result) => {
            if (result.data) {
              this.setState({
                loading: false,
                data: result.data,
               
              });
            } else {
              this.setState({ loading: false });
            }
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      };

    render() {
        const { onCancel, submitting, visible } = this.props;
        const { editMode, data } = this.state;
   const columns = [
     
         {
            title: Resources.dateAndTime,
            dataIndex: "created_at",
            className: "col-ltr",
            render: (val) => moment(val).format(Constants.jDateTimeFormat),
          },
      {
        title: `${Resources.search} `,
        dataIndex: "text",
        className: "col-center",
      },
   
      {
        title: `${Resources.user} `,
        dataIndex: "user",
        className: "col-center",
        render: (val) => val?.name + " "+ val?.family
      },
      // {
      //   title: `${Resources.count} `,
      //   dataIndex: "total",
      //   className: "col-center",
      // },
    ];
        return (
            <Modal
                // title={editMode ? Resources.edit : Resources.add}
                visible={visible}
                onOk={onCancel}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={1000}>
                <div className="ant-content">
                <Table
                    columns={columns}
                    dataSource={data}
                    // loading={loading}
                    // onChange={this.handleTableChange}
                    pagination={false}
                    size="small"
                    rowKey="id"
                    // scroll={{ x: 1000 }}
                />
                </div>
            </Modal>
        );
    }
};

export default SearchDetailForm;